export default "__VITE_ASSET__a2A95COm__"